// Copyright (c) 2024 by Audere

import { useGetQCConversationsQuery } from "../features/api/labelApiSlice";
import { selectCurrentUserPersistentGroupRole } from "../features/slices/authSlice";
import { useSelector } from "react-redux";
import { conversationLimit } from "../constants/conversation";
import { useCurrentUser } from "./useCurrentUser";

export const useQCConversations = (
  labelTypeID: string,
  offsetValue: number
) => {
  const userGroup = useSelector(selectCurrentUserPersistentGroupRole).group;
  const { isMonitor } = useCurrentUser();

  const { data, isLoading, error, refetch } = useGetQCConversationsQuery(
    {
      group: userGroup,
      labeling_type: labelTypeID,
      offset: offsetValue,
      limit: conversationLimit,
    },
    {
      pollingInterval: 10000,
      skipPollingIfUnfocused: true,
      refetchOnFocus: true,
      refetchOnReconnect: true,
      skip: !labelTypeID || isMonitor,
    }
  );

  const conversations = data?.conversations ?? [];
  const offset = data?.offset ?? 0;
  const endOfList = data?.end_of_list;

  return {
    conversations,
    offset,
    isLoading,
    error,
    endOfList,
    refetch,
  };
};
